import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  deleteBoothLinkOnline,
  deleteBoothLinkOffline,
} from "InteractiveMapAction";

class BoothLink extends Component {
  onLinkDelete = (e) => {
    if (!this.props.boothLink.islocal) {
      this.props.deleteBoothLinkOnline(
        this.props.session,
        this.props.boothLink,
        this.props.boothLink.type,
        this.props.selectedMap.interactivemapid
      );
    } else {
      this.props.deleteBoothLinkOffline(this.props.boothLink);
    }
  };

  render() {
    var title;

    /* [ WILL UNCOMMENT ON NEXT BUILD ] Dont delete*/
    if (this.props.boothLink.type === "session") {
      title = this.props.boothLink.title;
    } else if (this.props.boothLink.type === "speaker") {
      title = `${this.props.boothLink.firstname} ${this.props.boothLink.lastname}`;
    } else {
      title = this.props.boothLink.name;
    }

    return (
      <div className="row booth-links-div">
        <div className="col-md-10 vcenter booth-links-title">{title}</div>
        <div className="col-md-2 vcenter vertical-align-center-justify-right">
          <button
            className="btn btn-sm btn-delete modal-table-cross"
            onClick={this.onLinkDelete}
          >
            X
          </button>
        </div>
        <div className="col-md-12 booth-link-type">
          ({_.upperFirst(this.props.boothLink.type)})
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    toAddNewBooth: state.addEditBooth.toAddNewBooth,
    booth: state.addEditBooth.booth,
  };
}

export default connect(mapStateToProps, {
  deleteBoothLinkOnline,
  deleteBoothLinkOffline,
})(BoothLink);
